import { mergeClassNames } from "../../utils/classes";

import type { FC, ReactNode } from "react";

import * as styles from "./labelFor.module.scss";

interface LabelProps {
	label: ReactNode;
	hint?: ReactNode;
	className?: string | undefined;
	markAsRequired?: boolean | undefined;
}

export const Label: FC<LabelProps> = ({ label, hint, className, markAsRequired = false }) => {
	return (
		<div className={mergeClassNames(styles.floating, className)}>
			{label}
			{markAsRequired && <span className={styles.required}> *</span>}
			{hint && <small className={styles.hint}>{hint}</small>}
		</div>
	);
};
